var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep1To2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 86,
    viewBox: "0 0 102 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.7071 85.7071C94.3166 86.0976 93.6834 86.0976 93.2929 85.7071L86.9289 79.3431C86.5384 78.9526 86.5384 78.3195 86.9289 77.9289C87.3195 77.5384 87.9526 77.5384 88.3431 77.9289L94 83.5858L99.6569 77.9289C100.047 77.5384 100.681 77.5384 101.071 77.9289C101.462 78.3195 101.462 78.9526 101.071 79.3431L94.7071 85.7071ZM84 1L84 2L84 1ZM-4.10583e-08 0L84 0L84 2L4.10583e-08 2L-4.10583e-08 0ZM95 11L95 85H93L93 11H95ZM84 0C90.0751 0 95 4.92487 95 11H93C93 6.02944 88.9706 2 84 2L84 0Z",
    fill: "#134046"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1To2);
export default __webpack_public_path__ + "static/media/step_1_to_2.295037eda9c07dc498b5d8a8d82593ff.svg";
export { ForwardRef as ReactComponent };